// extracted by mini-css-extract-plugin
module.exports = {"container":"_2SHGnoKESph4T-ZQXLnoRd","cancel":"_2RidwDANDQlxUy9Bk4bRMI"};